import { getLevelDesignLayouts } from './levels'

export function getDesignLayoutForUnitPlan(plan) {
  console.log({plan})
  return plan.design_layout || getLevelDesignLayouts(plan.unit_type_level?.unit_type, plan.unit_type_level?.id).filter((d) => d.main_vendor.id === plan.vendor.id).find((d) => d.models.length > 0)
}
